<template>
    <section>
        <div class="c-section">
            <slot></slot>
        </div>
    </section>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
    .c-section{
        margin: 0 auto;
        max-width: 1342px;
        padding: 2rem .5rem;
    }
</style>